import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { getVideoSrc } from '../constants/constants';

export default function PracticeVideo({ }) {
    const { t, i18n } = useTranslation();
    return (
        <Box
            component="section"
            sx={{
                py: { xs: 8, md: 12 },
                px: { xs: 2, md: 4 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: 4,
                    }}
                >

                    <Typography
                        variant="h2"
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.2rem' },
                            fontWeight: 800,
                            lineHeight: 1.2,
                            color: '#1a202c',
                        }}
                    >
                        <Box
                            component="span"
                            sx={{
                                background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            {` ${t('PracticePlanningInMinutes00')} `}
                        </Box>
                        {` ${t('PracticePlanningInMinutes01')} `}
                    </Typography>

                    <Typography
                        sx={{
                            color: 'text.secondary',
                            maxWidth: 480,
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: '1.1rem',
                            lineHeight: 1.2,
                        }}
                    >
                        {t('PracticePlanningInMinutes02')}
                    </Typography>

                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                            width: '100%',
                            maxWidth: 900,
                            borderRadius: 8,
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                        }}
                    >
                        <source src={getVideoSrc('practice-planning-in-minutes', i18n.language)} type="video/mp4" />
                        Tu navegador no soporta el elemento de video.
                    </video>
                </Box>
            </Container>
        </Box>
    );
}
